import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=42812cf2&scoped=true"
import script from "./Display.vue?vue&type=script&lang=js"
export * from "./Display.vue?vue&type=script&lang=js"
import style0 from "./Display.vue?vue&type=style&index=0&id=42812cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42812cf2",
  null
  
)

export default component.exports